export default "__VITE_ASSET__8dXAUlBw__"